import { installComputerAgentTools } from "../computers/agentTools"
import { installControlTools } from "../appControls/tools"
import { VoiceSurface } from "../voice/VoiceSurface"
import type { ProductModule } from "./types"

export const appControlModule: ProductModule = {
    id: "app-control",
    install: () => {
        const disposers = [installComputerAgentTools(), installControlTools()]
        return () => {
            for (const dispose of disposers.reverse()) dispose()
        }
    },
    globalSurfaces: [VoiceSurface],
}
